module.exports = __webpack_public_path__ + "static/media/loading2.24de982c.gif";